import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const PriceContainer = styled(View, theme => {
  return {
    base: {
      flexDirection: 'column',
      marginTop: 'auto',
    },
  }
})

export const NoPriceContainer = styled(View, theme => {
  return {
    base: {
      flexDirection: 'column',
      marginTop: 'auto',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }
})

export const AvailabilityText = styled(Text, theme => {
  return {
    base: {
      textAlign: 'center',
      color: theme.colorTextNeutralAlternative,
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})

export const NoticeWhenAvailableText = styled(Text, theme => {
  return {
    base: {
      maxWidth: theme.sizingColossal,
      textAlign: 'center',
      color: theme.colorTextNeutralAlternative,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      paddingTop: theme.spacingInlineOnepulse,
    },
  }
})

export const OutOfStockText = styled(Text, theme => {
  return {
    base: {
      textAlign: 'center',
      color: theme.colorTextDangerAlternative,
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})

export const OldValueText = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralPlaceholder,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})

export const ValueText = styled(Text, theme => {
  return {
    base: {
      maxWidth: theme.sizingColossal,
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeFourpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeFourpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})
